// Utility Library used for many Patterns inside pattern library.
// Pattern Library seeks to minimize dependencies on libraries like jquery, allowing it to be used in a wider constiety of projects.
// This small set of utility functions allows us to write significantly less code by abstracting out common functions.
// Of particular note, functions that take functions as arguments are "function first", and a function for partial application/currying is provided.
// Function first is important because it allows us to compose useful functions in the patterns themselves, such as...
// const removeClassAll = PL.partial(PL.applyAll, PL.removeClass);
// removeClassAll is a function that takes element(s) and a class, and removes that class from all the element(s)

/* eslint-disable */

const PL_utils = {
  addClass: function (targetClass, el) {
    if (el.classList) {
      el.classList.add(targetClass);
    } else if (el.getAttribute) {
      var className = el.getAttribute('class')
      const arr = className.split(' ');
      if (arr.indexOf(targetClass) == -1) {
        className += ' ' + targetClass;
      }
      el.setAttribute('class', className);
    } else {
      const arr = el.className.split(' ');
      if (arr.indexOf(targetClass) == -1) {
        el.className += ' ' + targetClass;
      }
    }
  },
  removeClass: function (targetClass, el) {
    if (el.classList) {
      el.classList.remove(targetClass);
    } else if (el.getAttribute) {
      el.setAttribute('class', el.getAttribute('class').replace(new RegExp('(^|\\b)' + targetClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' '));
    } else {
      el.className = el.className.replace(new RegExp('(^|\\b)' + targetClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  },
  hasClass: function (targetClass, el) {
    if (el.classList) {
      return el.classList.contains(targetClass);
    } else if (el.getAttribute) {
      return new RegExp('(^| )' + targetClass + '( |$)', 'gi').test(el.targetClass);
    } else {
      return new RegExp('(^| )' + targetClass + '( |$)', 'gi').test(el.getAttribute('class'));
    }
  },
  toggleClass: function (targetClass, el) {
    const lib = this;
    if (lib.hasClass(targetClass, el)) {
      lib.removeClass(targetClass, el);
    } else {
      lib.addClass(targetClass, el);
    }
  },
  applyAll: function (fun) {
    const args = [].slice.call(arguments);
    const els = args[args.length - 1]; // target elements always last argument passed in.
    if (els instanceof NodeList) {
      [].map.call(els, function (el) {
        // funargs should exclude the first element passed (the function) and the last argument passed (the elements we're iterating over)
        const funargs = args.slice(1, args.length - 1).concat([el]);
        fun.apply(null, funargs);
      })
    } else {
      const funargs = args.slice(1, args.length - 1).concat([els]);
      fun.apply(null, funargs);
    }
  },
  partial: function (fun) {
    const partialArgs = [].slice.call(arguments);
    const passedArgs = partialArgs.slice(1);
    return (function () {
      const args = [].slice.call(arguments);
      const funargs = passedArgs.concat(args.slice());
      fun.apply(null, funargs);
    })
  },
  eleOnClick: function (fun, els) {
    if (els instanceof NodeList) {
      [].map.call(els, function (el) {
        el.addEventListener('click', fun);
      });
    } else {
      els.addEventListener('click', fun);
    }
  },
  createElement: function (tag, content, newClass) {
    const lib = this;
    const container = document.createElement(tag);
    const containerContent = document.createTextNode(content);
    container.appendChild(containerContent);
    lib.addClass(newClass, container);
    return container;
  },
  closest: function (ancestor, el) {
    const matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    if (!document.documentElement.contains(el)) {
      console.error('pl-utils.closest couldn\'t find child element target');
      return false;
    }
    do {
      if (matches.call(el, ancestor)) { return el; }
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    console.error('pl-utils.closest couldn\'t find matching ancestor of element');
    return false;
  }
};

export default PL_utils;